import { useDispatch } from '@redux';
import { confirmRefund } from '@redux/orders/actions';
import { Button, Col, Form, Input, Row } from 'antd';
import ModalCustom from 'components/commons/ModalCustom';
import React, { forwardRef, useImperativeHandle, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DynamicObjectType } from 'types/commons';

const ConfirmRefundModal = ({ data }, ref) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  const [form] = Form.useForm();

  useImperativeHandle(
    ref,
    () => ({
      openModal: () => setIsOpen(true),
    }),
    [],
  );

  const handleCancel = () => {
    setIsOpen(false);
  };

  const handleConfirmRefund = () => {
    form.validateFields().then((values) => {
      setLoading(true);
      dispatch(
        confirmRefund({
          data: {
            id: data?.id,
            data: {
              ...values,
            },
          },
          options: {
            isShowSuccessNoti: true,
          },
        }),
      ).then((res: DynamicObjectType) => {
        setIsOpen(false);
        setLoading(false);
        if (!res?.payload?.error) {
          window.location.reload();
        }
      });
    });
  };

  return (
    <ModalCustom
      open={isOpen}
      onCancel={handleCancel}
      title={t('orders.confirmRefund')}
      width={650}
      footer={null}
    >
      <Form form={form} layout="vertical" onFinish={handleConfirmRefund}>
        <Row>
          <Col span={24}>
            <Form.Item name="reason" label="Note">
              <Input.TextArea />
            </Form.Item>
          </Col>
        </Row>
        <div className="d-flex flex-end">
          <Button
            loading={loading}
            type="primary"
            htmlType="submit"
            className="ml-[5px]"
          >
            {t('button.ok')}
          </Button>
        </div>
      </Form>
    </ModalCustom>
  );
};

export default forwardRef(ConfirmRefundModal);
